import ModeloCrud from './ModeloCrud'
export {ModeloCrud}
export default ModeloCrud
